export default function OnlineIndicator({ isOnline }) {
  return (
    <div className={`fixed top-0 right-0 m-4 px-3 py-1 rounded-full text-sm font-medium z-50 no-print ${
      isOnline
        ? 'bg-green-100 text-green-800'
        : 'bg-red-100 text-red-800'
    }`}>
      <span className="inline-block w-2 h-2 rounded-full mr-2" style={{
        backgroundColor: isOnline ? '#22c55e' : '#ef4444'
      }} />
      {isOnline ? 'Online' : 'Offline'}
    </div>
  );
}
